export default {"src":"/_next/static/image/public/images/ic_bell.6d723a9d04e795ced9d6f1cc35febcbf.svg","height":21,"width":20};